import React, { Component } from 'react'
import { Table } from 'antd';

export class ProductsOnSaleTable extends Component {
  render() {

    const columns = [
      { title: 'Image', dataIndex: 'productImage', key: 'productImage', width: 80, render: (productImage) => <img src={productImage} alt="" className="table-image" /> },    
      { title: 'Product', dataIndex: 'productNaam', key: 'productNaam' },
      { title: 'Prijs', dataIndex: 'productPrijs', key: 'productPrijs', render:(text, record) => `${new Intl.NumberFormat('IN', { style: 'currency', currency: 'SRD'}).format(`${(record.productPrijs)}`)}`  },
      { title: 'Sales prijs', dataIndex: 'salesPrice', key: 'salesPrice', render:(text, record) => `${new Intl.NumberFormat('IN', { style: 'currency', currency: 'SRD'}).format(`${(record.salesPrice)}`)}`  }
    ];

    return (
      <div>
        <Table
          className="sales-table"
          columns={columns}
          locale={{...this.props}}
          {...this.props}
        />
      </div>
    )
  }
}

export default ProductsOnSaleTable
